<template>
  <div>
    <h3 class="mb-2">Plan and Billing</h3>

    <b-row>
      <b-col
        cols="12"
        md="4"
        class="mb-2"
      >
        <b-card class="plan-card h-100">
          <div class="d-flex align-items-center justify-content-between mb-1">
            <h4 class="mb-0">Basic</h4>
            <b-badge variant="light-success">Current plan</b-badge>
          </div>
          <p class="mb-50 font-weight-bold">
            Essential CRM features
          </p>
          <p class="mb-1 text-muted">
            For getting started
          </p>
          <p class="mb-0 text-muted">
            Renew date: renews automatically
          </p>
          <p class="plan-price-free mb-0 mt-2">
            FREE
          </p>
        </b-card>
      </b-col>

      <b-col
        cols="12"
        md="4"
        class="mb-2"
      >
        <b-card class="plan-card h-100">
          <h4 class="mb-1">Professional</h4>
          <p class="mb-50 font-weight-bold">
            Advanced tools &amp; automation
          </p>
          <p class="mb-1 text-muted">
            For growing businesses
          </p>
          <p class="plan-coming-soon mb-0">
            Coming soon
          </p>
        </b-card>
      </b-col>

      <b-col
        cols="12"
        md="4"
        class="mb-2"
      >
        <b-card class="plan-card h-100">
          <h4 class="mb-1">Enterprise</h4>
          <p class="mb-50 font-weight-bold">
            Everything included
          </p>
          <p class="mb-1 text-muted">
            For high-volume teams
          </p>
          <p class="plan-coming-soon mb-0">
            Coming soon
          </p>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BBadge,
  BCard,
  BCol,
  BRow,
} from 'bootstrap-vue'

export default {
  name: 'PlanAndBilling',
  components: {
    BBadge,
    BCard,
    BCol,
    BRow,
  },
}
</script>

<style scoped>
.plan-card {
  border: 1px solid rgba(34, 41, 47, 0.1);
}

.plan-price-free {
  text-align: center;
  color: #b9b9c3;
  font-weight: 700;
  font-size: 2.5rem;
  line-height: 1.2;
}

.plan-coming-soon {
  text-align: center;
  color: #b9b9c3;
  font-size: 1.25rem;
  padding-top: 1.5rem;
}
</style>
